export default __webpack_public_path__ + "static/media/loading.983e7bd7.svg";